import { RootState } from 'modules'
import { RecoveryEmailPopupState } from './duck'

export const selectRecoveryEmailPopup = (
  state: RootState
): RecoveryEmailPopupState => state.recoveryEmailPopup
